import { useDispatch, useSelector } from "react-redux";
import { setStrikersByTournament } from "../redux/actions";
import { useGetPlayersByTournament } from "./useGetPlayersByTournament";

export const useGetStrikersPlayer = ()=>{
        const selectedTournament = useSelector(state => state?.tournaments?.selectedTournament)
        const strikersByTournament = useSelector(state => state?.strikerPlayer?.strikersByTournament)
        const strikerOrder = strikersByTournament?.sort(function compareFn(a, b) {
            if (a.goles < b.goles) {
              return 1;
            } else if (a.goles > b.goles) {
              return -1;
            }
            // a must be equal to b
            return 0;
          }).filter(player => player.goles > 0)
    

        useGetPlayersByTournament({setUpPlayers : setStrikersByTournament});
    


        return {
            selectedTournament,
            strikerOrder
        }

}